import mutations from './mutations'
import getters from './getters'
import actions from './actions'

const state = {
  tags: [],
  ramais: [],
  conferencias: [],
  centroDeCustos: [],
  dadosRelatorio: {},
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
